import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ReactSelect from 'react-select';

import { MONTH_NAMES } from '../../services/dates';
import eventMonthSplitter, { removeEmptyMonth } from '../../services/event-month-splitter';

export const EventMonthFilterStyles = {
	DorpdownContainer: styled.div`
		padding: 0em;
		width: 100%;
		display:flex;
		justify-content: flex-start;
	`,
	Dropdown: styled(ReactSelect)`
		width:100%;
		.react-select__control {
			border: 1px solid #eee;
			box-shadow: none;
			width: 100%;
			border-radius: 2px;
			&:hover {
				border: 1px solid #eee;
				box-shadow: none;
			}
			&:focus {
				border: 1px solid #eee;
				box-shadow: none;
			}
		}
	`,

};

const S = EventMonthFilterStyles;

const EventMonthFilter = ({ events, dropdownEvents, updateEvents }) => {
	const splitted = removeEmptyMonth(eventMonthSplitter(dropdownEvents));
	const keys = Object.keys(splitted).sort();

	const handleSelection = (e) => {
		const key = e.value;
		if (key === 'all') {
			updateEvents(events);
		} else {
			updateEvents(splitted[key]);
		}
	};

	const years = keys
		.map(key => moment.unix(key).year())
		.sort()
		// da sortiert filtern wir nur was ungleich dem vorgänger ist.
		.filter((val, index, arr) => val !== arr[index - 1]);

	const groupedOptions = [
		{
			label: '',
			options: [{
				value: 'all',
				label: 'alle Monate',
			}],
		},
	];
	years.forEach((year) => {
		const options = keys.filter(key => moment.unix(key).year() === year)
			.map(key => (
				{
					value: key,
					label: `${MONTH_NAMES[moment.unix(key).month()]}`,
				}
			));
		groupedOptions.push({
			label: year,
			options,
		});
	});

	return (
		<S.DorpdownContainer>
			<S.Dropdown
				options={groupedOptions}
				onChange={handleSelection}
				placeholder="Monat auswählen"
				classNamePrefix="react-select"
			/>
		</S.DorpdownContainer>
	);
};

export default EventMonthFilter;
